package com.bikompanion.data.gbfs

import kotlinx.serialization.Serializable

@Serializable
internal data class GbfsStationStatusData(
    val stations: List<GbfsStationStatusDto>,
)
